import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LauncherElementData, useLauncherElementsStore } from '../../hooks/stores/launcherElementsStore';
import { UIData, useUIStore } from '../../hooks/stores/uiStore';

export const ElementCursors = ({ data, $isElementSelected }: { data: string[]; $isElementSelected?: boolean }) => {
  return (
    <>
      {data.map((elementID) => (
        <Cursor $isElementSelected={$isElementSelected} key={`element-cursor-${elementID}`} elementID={elementID} />
      ))}
    </>
  );
};

const Cursor = ({ elementID, $isElementSelected }: { elementID: string; $isElementSelected?: boolean }) => {
  const [rect, setRect] = useState<{
    top?: number;
    left?: number;
    width?: number;
    height?: number;
  }>({} as DOMRect);
  const [UIData] = useUIStore<UIData>({ selector: ['sceneZoom'] });
  const [launcherElementsData] = useLauncherElementsStore<Record<string, LauncherElementData>>();

  useEffect(() => {
    const zoom = UIData.sceneZoom;
    const elementDiv = document.getElementById(elementID);
    const windowDiv = document.getElementById('launcherWindow');
    const elementRect = elementDiv?.getBoundingClientRect();
    const windowRect = windowDiv?.getBoundingClientRect();
    if (!elementRect || !windowRect) return;
    setRect({
      top: (elementRect.top - windowRect.top) / zoom,
      left: (elementRect.left - windowRect.left) / zoom,
      width: elementRect.width / zoom,
      height: elementRect.height / zoom,
    });
  }, [launcherElementsData[elementID]]);

  const isZeroSize = !rect.width || rect.width === 0 || !rect.height || rect.height === 0;

  return (
    !isZeroSize && (
      <CursorContainer
        $isElementSelected={$isElementSelected}
        style={{
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
        }}
      />
    )
  );
};

const CursorContainer = styled.div<{ $isElementSelected?: boolean }>`
  pointer-events: none;
  position: absolute;
  outline: 1px solid var(--primary-1);

  ${({ $isElementSelected }) =>
    $isElementSelected &&
    `
    outline: 1px solid #eee;
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      outline: 1px dashed #333;
      pointer-events: none;
    }
    opacity: 0.5;
  `}
`;
